import {
  Approval,
  Cancel,
  Check,
  Delete,
  DoDisturb,
  OpenInNew,
  PlagiarismSharp,
  WarningAmber
} from '@mui/icons-material';
import { Badge, Button, ButtonProps, lighten } from '@mui/material';
import { GridRowSelectionModel } from '@mui/x-data-grid';

import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';

interface ButtonPropsWithInvoices extends ButtonProps {
  selectedInvoices?: GridRowSelectionModel;
}

const ButtonBase = (props: ButtonProps) => {
  return (
    <Button
      {...props}
      variant="contained"
      style={{ maxHeight: '2.6em' }}
      sx={{
        ...props.sx,
        //@ts-expect-error backgroundColor is missing
        '&:hover': { backgroundColor: lighten(props.sx?.backgroundColor, 0.1) }
      }}
      fullWidth
    />
  );
};

export const OpenInDMSButton = (props: ButtonProps) => {
  const { t } = useTranslation();
  return (
    <ButtonBase {...props} startIcon={<OpenInNew />} sx={{ backgroundColor: '#3498db' }}>
      {t(translations.pages.billing.openInDMS())}
    </ButtonBase>
  );
};

export const ApproveInvoicesButton = ({ selectedInvoices, ...props }: ButtonPropsWithInvoices) => {
  const { t } = useTranslation();
  return (
    <Badge badgeContent={props.disabled ? 0 : selectedInvoices?.length} color="secondary">
      <ButtonBase {...props} startIcon={<Approval />} sx={{ backgroundColor: '#5a5' }}>
        {t(translations.pages.billing.approveInvoice())}
      </ButtonBase>
    </Badge>
  );
};

export const CancelInvoicesButton = ({ selectedInvoices, ...props }: ButtonPropsWithInvoices) => {
  const { t } = useTranslation();
  return (
    <Badge badgeContent={selectedInvoices?.length} color="secondary">
      <ButtonBase {...props} startIcon={<Cancel />} sx={{ backgroundColor: '#e33' }}>
        {t(translations.pages.billing.cancelInvoice())}
      </ButtonBase>
    </Badge>
  );
};

export const DeleteInvoiceButton = ({ selectedInvoices, ...props }: ButtonPropsWithInvoices) => {
  const { t } = useTranslation();
  return (
    <ButtonBase {...props} startIcon={<Delete />} sx={{ backgroundColor: '#e33' }}>
      {t(translations.pages.billing.deleteInvoice())}
    </ButtonBase>
  );
};

export const DenyInvoicesButton = ({ selectedInvoices, ...props }: ButtonPropsWithInvoices) => {
  const { t } = useTranslation();
  return (
    <Badge badgeContent={selectedInvoices?.length} color="secondary">
      <ButtonBase {...props} startIcon={<DoDisturb />} sx={{ backgroundColor: '#e33' }}>
        {t(translations.pages.billing.denyInvoice())}
      </ButtonBase>
    </Badge>
  );
};

export const ToCanceledInvoiceButton = ({ ...props }: ButtonPropsWithInvoices) => {
  const { t } = useTranslation();
  return (
    <ButtonBase {...props} startIcon={<OpenInNew />} sx={{ backgroundColor: '#e33' }}>
      {t(translations.pages.billing.toCancelledInvoice())}
    </ButtonBase>
  );
};

export const ToOriginalnvoiceButton = ({ ...props }: ButtonPropsWithInvoices) => {
  const { t } = useTranslation();
  return (
    <ButtonBase {...props} startIcon={<OpenInNew />} sx={{ backgroundColor: '#e33' }}>
      {t(translations.pages.billing.toOriginalInvoice())}
    </ButtonBase>
  );
};

export const MarkAsReadyButton = ({ ...props }: ButtonPropsWithInvoices) => {
  const { t } = useTranslation();
  return (
    <ButtonBase {...props} startIcon={<WarningAmber />} sx={{ backgroundColor: '#f39100' }}>
      {t(translations.pages.billing.detail.markAsReady())}
    </ButtonBase>
  );
};
export const PdfPreview = ({ ...props }: ButtonPropsWithInvoices) => {
  const { t } = useTranslation();
  return (
    <ButtonBase {...props} startIcon={<PlagiarismSharp />} sx={{ backgroundColor: '#f39100' }}>
      {t(translations.pages.billing.detail.pdfPreview())}
    </ButtonBase>
  );
};
//Only visable for not finanzUser
export const MarkedAsReady = () => {
  const { t } = useTranslation();
  return (
    <ButtonBase
      startIcon={<Check />}
      sx={{
        backgroundColor: '#5a5',
        pointerEvents: 'none',
        cursor: 'not-allowed'
      }}
    >
      {t(translations.pages.billing.detail.markedAsReady())}
    </ButtonBase>
  );
};
